<template>
    <div class="unified-connections">
      <h2 class="mb-2" v-if="connections?.length && unifiedDataType === 'candidate'">{{ resource["unified.candidatesTitle"] }}</h2>
      <div class="unified-connections__select-area">
        <div class="unified-connections__select-item">
          <h3 v-if="unifiedDataType === 'job'" class="unified-connections__select-label">{{ resource["unified.AtsTitle"] }}</h3>
          <multiselect
            ref="multiselect-connection"
            id="unified-connections-select"
            key="unified-connections-select"
            class="unified-connections__select"
            v-model="selectedConnectionModel"
            :placeholder="connectionLoading ? resource['placeholderLoading'] : resource['placeholderUnifiedSelectAts']"
            track-by="name"
            :options="connections"
            :custom-label="customLabel"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :hide-selected="false"
            :preselect-first="true"
            :max-height="270"
            :loading="connectionLoading"
            :disabled="connectionLoading"
            @input="onInputAts(selectedConnectionModel?.type)"
          >
            <template #singleLabel="props">
              <span class="option__desc">
                <span class="option__title">
                  {{ props.option.name }}
                </span>
              </span>
            </template>
            <template #option="props">
              <div class="option__desc justify-content-between">
                <span class="option__title">{{ props.option.name }}</span>
              </div>
            </template>
            <template #noOptions>
              <span v-if="!connectionLoading"> {{ resource['label.NoResult'] }}</span>
            </template>
            <template #noResult>
              <span v-if="!connectionLoading">{{ resource['label.NoResult'] }}</span>
            </template>
            <template slot="afterList">
              <div class="unified-connections__select-afterlist">
                <button @click="routeIntegrationsPage()" class="add-btn"><i class="icon-add"></i> {{ resource['interviewDetail.AtsIntegrationCreateNewConnection'] }}</button>
              </div>
            </template>
          </multiselect>
        </div>
        <div class="unified-connections__select-item">
          <multiselect
            v-if="unifiedDataType === 'candidate'"
            ref="multiselect-candidate"
            id="unified-candidates-select"
            key="unified-candidates-select"
            class="unified-connections__select"
            v-model="selectedCandidate"
            :placeholder="candidateLoading ? resource['placeholderLoading'] : resource['placeholderUnifiedSelectCandidate']"
            track-by="name"
            :custom-label="customLabelCandidate"
            :options="atsData.candidates"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preselect-first="true"
            :preserve-search="true"
            :max-height="270"
            :loading="candidateLoading"
            :disabled="!selectedConnection || (atsData.candidates?.length < 1 && candidateLoading)"
            v-b-tooltip.hover.bottom="{disabled: selectedConnection, customClass: 'ats-job-tooltip'}" :title="!selectedConnection ? resource['interviewDetail.AtsIntegrationTooltip'] : ''"
          >
            <template #selection="{ values, isOpen }">
              <span class="multiselect__single"
                    v-if="values.length"
                    v-show="!isOpen">{{ values.length }} {{ resource['unifiedCandidatesSelected'] }}</span>
            </template>
            <!-- <template #singleLabel="props">
              <span class="option__desc">
                <span class="option__title">{{ props.option.name }} {{ props.option.emails ? ` - ${props.option.emails?.[0]?.email}` : '' }}</span>
              </span>
            </template> -->
            <template #option="props">
              <div class="option__desc" v-b-tooltip.hover="{disabled: props.option.emails}" :title="!selectedConnection ? resource['unifiedNoEmailCandidateTooltip'] : ''">
                <span class="option__title">{{ props.option.name }} {{ props.option.emails ? ` - ${props.option.emails?.[0]?.email}` : '' }}</span>
              </div>
            </template>
            <template #noOptions>
              <span>{{ resource['label.NoResult'] }}</span>
            </template>
            <template #noResult>
              <span>{{ resource['label.NoResult'] }}</span>
            </template>
            <template slot="afterList">
              <div v-observe-visibility="{ callback: reachedEndOfListCandidates, once: false }" v-if="hasNextPageCandidates" class="multiselect__option multiselect__option--group d-flex justify-content-center">
                <i v-if="candidateLoading" class="icon-spinner icon-spin" width="14" height="14" />
                <span class="ml-2" v-if="candidateLoading">{{ resource['placeholder.loading'] }}</span>
              </div>
            </template>
          </multiselect>
          <h3 v-if="unifiedDataType === 'job'" class="unified-connections__select-label">{{ resource['unified.JobTitle'] }}</h3>
          <multiselect
            v-if="unifiedDataType === 'job'"
            ref="multiselect-job"
            id="unified-jobs-select"
            key="unified-jobs-select"
            class="unified-connections__select"
            v-model="interview.selectedJob"
            :placeholder="jobLoading ? resource['placeholderLoading'] : resource['placeholderUnifiedSelectJob']"
            track-by="name"
            :custom-label="customLabelJob"
            :options="atsData.jobs"
            :multiple="false"
            :close-on-select="true"
            :hide-selected="false"
            :preselect-first="true"
            :max-height="270"
            :loading="jobLoading"
            @select="setJobData(interview?.selectedJob)"
            :disabled="!selectedConnectionModel || (atsData.jobs?.length < 1 && jobLoading)"
            v-b-tooltip.hover.bottom="{disabled: selectedConnectionModel, customClass: 'ats-job-tooltip'}" :title="!selectedConnectionModel ? resource['interviewDetail.AtsIntegrationTooltip'] : ''"
          >
            <template #option="props">
              <div class="option__desc">
                <span class="option__title">{{ props.option.name }}</span>
              </div>
            </template>
            <template #noOptions>
              <span>{{ resource['label.NoResult'] }}</span>
            </template>
            <template #noResult>
              <span>{{ resource['label.NoResult'] }}</span>
            </template>
            <template slot="afterList">
              <div v-observe-visibility="{ callback: reachedEndOfListJobs, once: false }" v-if="hasNextPageJobs" class="multiselect__option multiselect__option--group d-flex justify-content-center">
                <i v-if="jobLoading" class="icon-spinner icon-spin" width="14" height="14" />
                <span class="ml-2" v-if="candidateLoading">{{ resource['placeholder.loading'] }}</span>
              </div>
            </template>
          </multiselect>
        </div>
      </div>
      <button v-if="unifiedDataType === 'candidate'" @click="addSelectedCandidate()" class="border-button-candidates mt-2" :disabled="!selectedCandidate?.length">
        {{ resource['unifiedAddSelectedCandidates'] }}
      </button>
    </div>
  </template>

<script>
import Multiselect from 'vue-multiselect';
import hrvenueService from '../../services/hrvenue.service';
import { showNotification } from '../../static/helpers';

export default {
  name: 'UnifiedConnections',
  components: {
    Multiselect,
  },
  props: {
    unifiedDataType: {
      type: String,
      required: true,
    },
    interview: {
      type: Object,
      default: () => {},
    },
    generateQuestionWithAiRight: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      connections: [],
      loading: false,
      atsData: {
        candidates: [],
        jobs: [],
      },
      currentOffsetCandidate: 0,
      currentOffsetJob: 0,
      currentConnectionType: null,
      selectedConnection: null,
      selectedCandidate: null,
      hasNextPageCandidates: true,
      hasNextPageJobs: true,
      connectionLoading: false,
      candidateLoading: false,
      jobLoading: false,
    };
  },

  created() {
    this.getUnifiedAts();
  },

  computed: {
    selectedConnectionModel: {
      get() {
        return this.unifiedDataType === 'job' ? this.interview.selectedConnection : this.selectedConnection;
      },
      set(value) {
        if (this.unifiedDataType === 'job') {
          this.$set(this.interview, 'selectedConnection', value);
        } else {
          this.selectedConnection = value;
        }
      },
    },
  },

  methods: {
    routeIntegrationsPage() {
      const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

      this.$router.push({ name: 'IntegrationsView', params: { lang } });
    },
    addSelectedCandidate() {
      if (!this.selectedCandidate?.length) return;

      this.selectedCandidate.forEach((item) => {
        if (!this.atsData.candidates.find((c) => c.id === item.id)?.isSelected) {
          this.addCandidate(item);
        }
      });

      this.selectedCandidate = null;
    },

    addCandidate(candidate) {
      // Eğer aday zaten seçili ise işlemi iptal et
      if (this.atsData.candidates.find((c) => c.id === candidate.id)?.isSelected) {
        return;
      }

      // Adayı seçili olarak işaretle
      this.atsData.candidates = this.atsData.candidates.map((item) => (item.id === candidate.id ? { ...item, isSelected: true } : item));

      const [firstName, ...lastNameParts] = candidate.name.split(' ');
      const newRow = {
        name: firstName,
        surname: lastNameParts.join(' '), // Soyadında boşluk varsa hepsini birleştir
        email: candidate.emails?.[0]?.email,
        key: 'ats',
      };

      this.$emit('createNewInterViewer', null, newRow);
    },
    // eslint-disable-next-line camelcase
    customLabel({ name }) {
      // eslint-disable-next-line camelcase
      return `${name}`;
    },
    customLabelCandidate(props) {
      if (!props.emails) {
        return `${props.name}`;
      }
      return `${props.name} - ${props.emails?.[0]?.email}`;
    },

    customLabelJob(props) {
      return `${props.name}`;
    },

    async getUnifiedAts() {
      try {
        this.connectionLoading = true;
        const response = await hrvenueService.getUnifiedIntegrations();
        // this.connections = response.map((item) => (item.connected ? item : { ...item, $isDisabled: true })).sort((a, b) => b.connected - a.connected);
        this.connections = response?.filter((item) => item.connected);
        if (this.connections.length > 0 && !this.selectedConnectionModel) {
          this.selectedConnectionModel = this.connections[0];
          this.onInputAts(this.connections[0].type);
        }
      } catch (error) {
        showNotification(
          this.resource['label.error'],
          error.message,
          'error',
        );
      } finally {
        this.connectionLoading = false;
      }
    },

    onInputAts(type) {
      if (this.unifiedDataType === 'candidate') {
        this.fetchAtsCandidate(type);
      } else {
        this.$set(this.interview, 'selectedJob', null);
        this.$set(this.interview, 'jobDescription', null);
        if (type) {
          this.fetchAtsJobs(type);
        }
      }
    },

    setJobData(connection) {
      if (this.generateQuestionWithAiRight > 0) {
        if (connection?.description) {
          this.$set(this.interview, 'jobDescription', connection?.description?.replace(/<[^>]*>?/gm, ''));
        } else {
          this.$set(this.interview, 'jobDescription', null);
        }
      }
    },

    async fetchAtsCandidate(connectionType) {
      try {
        this.atsData.candidates = [];
        this.selectedCandidate = null;
        this.candidateLoading = true;
        this.currentConnectionType = connectionType;
        this.currentOffsetCandidate = 0;

        const candidates = await hrvenueService.getUnifiedData('ats', connectionType, 'candidate', `offset=${this.currentOffsetCandidate}&limit=50`);

        if (!candidates?.length) {
          this.hasNextPageCandidates = false;
          this.atsData.candidates = [];
        }

        if (candidates?.length < 50) {
          this.hasNextPageCandidates = false;
        }

        this.atsData.candidates = candidates?.map((item) => (item.emails ? item : { ...item, $isDisabled: true })) || [];
      } catch (error) {
        showNotification(
          this.resource['label.error'],
          error.message,
          'error',
        );
      } finally {
        this.candidateLoading = false;
      }
    },
    async fetchAtsJobs(connectionType) {
      try {
        this.atsData.jobs = [];
        this.jobLoading = true;
        this.currentConnectionType = connectionType;
        this.currentOffsetJob = 0;

        const jobs = await hrvenueService.getUnifiedData('ats', connectionType, 'job', `offset=${this.currentOffsetJob}&limit=50&fields=id,name,description,questions`);

        if (!jobs?.length) {
          this.hasNextPageJobs = false;
          this.atsData.jobs = [];
        }

        if (jobs?.length < 50) {
          this.hasNextPageJobs = false;
        }

        this.atsData.jobs = jobs || [];
      } catch (error) {
        showNotification(
          this.resource['label.error'],
          error.message,
          'error',
        );
      } finally {
        this.jobLoading = false;
      }
    },

    reachedEndOfListCandidates(reached) {
      if (reached && this.hasNextPageCandidates) {
        this.currentOffsetCandidate += 50;
        this.loadMoreCandidates(this.currentOffsetCandidate);
      }
    },

    async loadMoreCandidates(currentOffsetCandidate) {
      if (!this.currentConnectionType) return;

      try {
        this.candidateLoading = true;

        const candidates = await hrvenueService.getUnifiedData('ats', this.currentConnectionType, 'candidate', `offset=${currentOffsetCandidate}&limit=50`);

        if (candidates?.length) {
          const filteredCandidates = candidates?.map((item) => (item.emails ? item : { ...item, $isDisabled: true }));
          this.atsData.candidates = [...this.atsData.candidates, ...filteredCandidates];

          if (candidates?.length < 50) {
            this.hasNextPageCandidates = false;
          }
        }
      } catch (error) {
        showNotification(
          this.resource['label.error'],
          error.message,
          'error',
        );
      } finally {
        this.candidateLoading = false;
      }
    },

    reachedEndOfListJobs(reached) {
      if (reached && this.hasNextPageJobs) {
        this.currentOffsetJob += 50;
        this.loadMoreJobs(this.currentOffsetJob);
      }
    },

    async loadMoreJobs(currentOffsetJob) {
      if (!this.currentConnectionType) return;

      try {
        this.jobLoading = true;

        const jobs = await hrvenueService.getUnifiedData('ats', this.currentConnectionType, 'job', `offset=${currentOffsetJob}&limit=50`);

        if (jobs?.length) {
          const filteredCandidates = jobs?.map((item) => (item.emails ? item : { ...item, $isDisabled: true }));
          this.atsData.jobs = [...this.atsData.jobs, ...filteredCandidates];

          if (jobs?.length < 50) {
            this.hasNextPageJobs = false;
          }
        }
      } catch (error) {
        showNotification(
          this.resource['label.error'],
          error.message,
          'error',
        );
      } finally {
        this.jobLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/style/starter.scss';

.border-button-candidates {
  display: flex;
  padding: 6px 8px;
  justify-content: center;
  align-items: center;
  border-radius: 40px;
  border: 1px solid #D4D4D4;
  transition: all 0.2s ease-in-out;

  @media only screen and (max-width: map-get($grid-breakpoints, 'md')) {
    width: 100%;
  }

  span {
    color: #333;
    text-align: center;
    font-feature-settings: 'liga' off, 'clig' off;
    /* Typography/Button & Link/2(Button Label) - Bold */
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
    padding: 0 8px;
  }

  &:hover {
    background: #E5E5E5;
  }

  &.disabled {
    span {
      color: #fff !important;
    }

    svg {
      path {
        fill: #fff !important;
      }
    }
  }
}
.unified-connections {
  padding: 1.5rem;

  &__select-label {
    color: var(--Text-Colors-Primary-Gray-Text, #333);
    font-feature-settings: 'liga' off, 'clig' off;
    /* Typography/Subtitle/3 - Medium */
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    margin-bottom: 4px;
  }

  &__select-afterlist {
    position: sticky;
    bottom: 0;
    display: flex;
    height: 48px;
    padding: 14px 8px;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    border-radius: var(--Radius-XSmall, 2px);
    background: var(--Background-Colors-White, #FFF);
    border-top: 1px solid #E5E5E5;
  }

  &__select {
    ::v-deep #listbox-null {
      li:first-child {
        display: block !important;
      }
    }
  }

  &__select-area {
    display: flex;
    justify-content: space-between;

    @media only screen and (max-width: map-get($grid-breakpoints, 'md')) {
      flex-direction: column;
    }
  }

  &__select-item {
    width: 50%;

    &:first-child {
      margin-right: 8px;
    }

    @media only screen and (max-width: map-get($grid-breakpoints, 'md')) {
      width: 100%;
      margin-right: 0 !important;
      margin-top: 16px;
    }
  }
}
.card {
  transition: box-shadow 0.2s ease-in-out;

  &:hover {
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  }
}

.btn {
  &:disabled {
    cursor: not-allowed;
  }
}

::v-deep .multiselect {
  &__option--disabled {
    display: block !important;
    color: #C3C3C3 !important;
    pointer-events: auto !important;
    cursor: not-allowed !important;
  }

  &--active {
    .multiselect__tags {
      box-shadow: 0px 0px 0px 4px rgba(255, 141, 6, 0.30) !important;
      outline: 1px solid #FF8D06 !important;
      border-radius: 4px;
    }
  }

  &__content-wrapper {
    top: 48px;
    border-radius: 4px !important;
    border: 1px solid #E5E5E5 !important;
    background: #FFF;
    box-shadow: 0px 2px 12px 1px rgba(0, 0, 0, 0.12) !important;
  }

  &__tags {
    border-radius: 4px !important;
    padding: 10px 40px 0 8px !important;
  }

  &__option--highlight {
    background: #EEE !important;
  }

  &__select:before {
    content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M7.25537 9.51191L9.4137 11.6702C9.7387 11.9952 10.2637 11.9952 10.5887 11.6702L12.747 9.51191C13.272 8.98691 12.897 8.08691 12.1554 8.08691H7.8387C7.09703 8.08691 6.73037 8.98691 7.25537 9.51191Z" fill="%23333333"/></svg>');
    border: 0;
    top: 20%;
  }

  &__option--selected:after {
    content: "";
    display: none;
  }

  &--disabled {
    pointer-events: auto !important;
  }
}

.add-btn {
  color: var(--Text-Colors-Primary-Orange-Text, #FF8D06);
  font-feature-settings: 'liga' off, 'clig' off;
  /* Typography/Body/3 - Regular */
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;

  i {
    margin-top: 0 !important;
  }

  &:hover {
    opacity: 0.8;
  }
}

.ats-job-tooltip {
  opacity: 1 !important;

  &.bs-tooltip-right {
    ::v-deep .arrow {
      &::before {
        border: 0 !important;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="9" viewBox="0 0 17 9" fill="none"><path d="M17 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9Z" fill="%23DBF0F9"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9L15.5 9L14.6801 8L9.22701 2.22618C8.83239 1.80835 8.16761 1.80835 7.77299 2.22618L2.31993 8L1.5 9Z" fill="%23B7E1F3"/></svg>');
        width: 17px;
        height: 9px;
      }
    }
  }

  &.bs-tooltip-left {
    ::v-deep .arrow {
      &::before {
        border: 0 !important;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="9" viewBox="0 0 17 9" fill="none"><path d="M17 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9Z" fill="%23DBF0F9"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9L15.5 9L14.6801 8L9.22701 2.22618C8.83239 1.80835 8.16761 1.80835 7.77299 2.22618L2.31993 8L1.5 9Z" fill="%23B7E1F3"/></svg>');
        width: 17px;
        height: 9px;
        transform: rotate(180deg);
      }
    }
  }

  &.bs-tooltip-bottom {
    padding: 0 !important;
    top: 10px !important;

    ::v-deep .arrow {
      &::before {
        border: 0 !important;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="9" viewBox="0 0 17 9" fill="none"><path d="M17 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9Z" fill="%23DBF0F9"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9L15.5 9L14.6801 8L9.22701 2.22618C8.83239 1.80835 8.16761 1.80835 7.77299 2.22618L2.31993 8L1.5 9Z" fill="%23B7E1F3"/></svg>') !important;
        width: 17px;
        height: 9px;
        bottom: 5px;
      }
    }
  }

  ::v-deep .tooltip-inner {
    border: 1px solid var(--Stroke-Colors-Light-Blue-Stroke, #b7e1f3) !important;
    background: var(--Background-Colors-Light-Blue, #dbf0f9) !important;
    border-radius: 4px !important;
    padding: 8px 12px !important;
    width: fit-content !important;
    max-width: fit-content !important;
    box-shadow: 0px 2px 6px 0px rgba(176, 186, 197, 0.6) !important;

    text-align: left;
    color: var(--Text-Colors-Blue-Text, #114e67) !important;
    font-feature-settings: "liga" off, "clig" off;
    /* Typography/Small Text/1 - Regular */
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 150% */
  }
}
</style>
